import { combineReducers } from 'redux';

import config from './config';
import data from './data';

const reducer = combineReducers({ config, data });

export type CcmReducer = ReturnType<typeof reducer>;

export default reducer;
